import { AsyncPipe, DOCUMENT, UpperCasePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonComponent } from '@zero/shared/ui-web-design-system';
import { TradeFacade } from '@zero/trade/domain';
import { commonRoutes } from 'constants/web-app-constants';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { map } from 'rxjs';
import { KnowledgeAndExperienceComponent } from '../knowledge-and-experience/knowledge-and-experience.component';

@Component({
  selector: 'trade-multi-order-success',
  imports: [TranslocoPipe, LottieComponent, ButtonComponent, UpperCasePipe, AsyncPipe, KnowledgeAndExperienceComponent],
  templateUrl: './multi-order-success.component.html',
  styleUrl: './multi-order-success.component.scss',
})
export class MultiOrderSuccessComponent implements OnInit, OnDestroy {
  readonly #darkCssClass = 'dark';
  public readonly facade = inject(TradeFacade);
  public readonly document = inject(DOCUMENT);
  public router = inject(Router);

  public options: AnimationOptions = {
    path: '/assets/animatedgraphics/checkmark-update.json',
    loop: false,
  };

  public readonly isins$ = this.facade.multiOrderInstruments$.pipe(map((instruments) => instruments.map((instrument) => instrument.isin)));

  ngOnInit() {
    this.#addCssToBody();
  }

  ngOnDestroy() {
    this.#removeCssFromBody();
  }

  public navigateToDepot() {
    this.#navigate(commonRoutes.postlogin.member_home);
  }

  public navigateToOrders() {
    this.#navigate(commonRoutes.postlogin.orders);
  }

  #navigate = (route: string) => this.router.navigate([route]);
  #removeCssFromBody = () => this.document.body.classList.remove(this.#darkCssClass);
  #addCssToBody = () => this.document.body.classList.add(this.#darkCssClass);
}
